import React, { ReactNode } from 'react';
import { TypePageTitle } from '@c2fo/react-components';

export function PageTitle(props: { children: ReactNode }) {
  return <TypePageTitle {...props} />;
}
